export const customerResetPasswordMutation = /* GraphQL */ `
  mutation customerResetPassword($token: String!, $newPassword: String!) {
    customerResetPassword(tokenValue: $token, newPassword: $newPassword) {
      id
    }
  }
`
